export const wallets = [
    {
        id:1,
        name: 'Metamask'
    },
    {
        id:2,
        name: 'Phantom'
    },
]